import ManagerRepository from 'coreClasses/ManagerRepository';
import createCtx from 'coreUtils/createCtx';

export const [useGeneralProvider, GeneralProvider] = createCtx<{
	managerRepository: ManagerRepository;
	setRef: (id, value) => void,
	getRef: (id) => any|null,
	isAppLoading: boolean,
	setIsAppLoading: (value) => void,
	getEnvPreference: (value) => string
}>();
